import BaseComponent from "./BaseComponent";
import Button from "./Button";
import Input from "./Input";
import Utility from "../utilities/Utility";
import LocalIntentSubCon from "./submenu_contents/LocalIntentSubCon";
import BaseLinkModel from "../models/BaseLinkModel";
import InputNodeModel from "../models/nodes/InputNodeModel";

export default class Condition extends BaseComponent {
    /**
     * Transition condition component
     * @module Condition
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value ? this.props.value : []
        };
    }

    /**
     * Set config proxy; filter empty values before updating context
     * @param {string} key
     * @param {string} value
     */
    setConfig(key, value) {
        const idx = key.split("::");

        const values = this.state.value;
        values[idx[0]][idx[1]] = value;
        const filtered = this.filterValue(values);
        this.updateContext(filtered);
        this.setState({value: filtered});

        
    }

    /**
     * Get condition based on key index
     * @param {string} key
     * @returns {string} Condition string
     */
    getConfig(key) {
        const idx = key.split("::");
        return this.state.value[idx[0]][idx[1]];
    }

    /**
     * Filter empty conditions
     * @param {Array} values
     * @returns {Array}
     */
    filterValue(values) {
        var filtered = [];
        for (var i = 0; i < values.length; i++) {
            var and = [];
            for (var j = 0; j < values[i].length; j++) {
                if (values[i][j]) {
                    and.push(values[i][j]);
                }
            }
            if (and.length) {
                filtered.push(and);
            }
        }
        return filtered;
    }


    /**
     * Render AND condition group
     * @param {string|number} key View key
     * @param {Array} data Array of clauses to be joined by AND
     * @returns {XML}
     */
    renderAnd(key, data) {
        const isInputNode = this.props.context instanceof BaseLinkModel && this.props.context.getSourceNode() instanceof InputNodeModel;
        const submenuContext = {
            add: (itemData) => {
                this.setState(prevState => {
                    const intentIdx = window.apm.knowledgeBase.getIntentIndexFromValue(itemData);
                    const intent = window.apm.knowledgeBase.getIntents()[intentIdx];
                    const sourceNode = this.props.context instanceof BaseLinkModel ? this.props.context.getSourceNode() : null;
                    if (sourceNode instanceof InputNodeModel) {
                        const localIntents = sourceNode.props.config.localIntents?sourceNode.props.config.localIntents:[];
                        if (localIntents.indexOf(itemData) === -1) {
                            const updatedLocalIntents = [...localIntents, itemData];
                            sourceNode.setConfig("localIntents", updatedLocalIntents);
                            window.apm.updateParentNode(sourceNode, sourceNode.props.parentComponentID, "localIntents", updatedLocalIntents);
                        }

                        const values = prevState.value;
                        const v = "out == \"" + intent.name + "\"";
                        if (values[key]) {
                            values[key].push(v);
                        } else {
                            values[key] = [v];
                        }
                        const filtered = this.filterValue(values);
                        this.updateContext(filtered);
                        return { value: filtered };
                    }
                });
            }
        };
        return (
            <div key={key} className={"condition-and"}>
                {(() => {
                    var exps = [];
                    for (var i = 0; i < data.length; i++) {
                        const compKey = key + "::" + i;
                        exps.push(
                            <table key={compKey}><tbody><tr>
                                <td>
                                    {/* // see https://jira.interactions.net/browse/CORE-33753: YES/NO Conditions input suggestion selection sets wrong value
                                    // suggestion and localSuggestion props below need to be uncommented in order to work on this ticket */}
                                    <Input 
                                        context={this} 
                                        valKey={compKey} 
                                        value={data[i]} 
                                        // suggestion={"variable"} 
                                        // localSuggestion={this.props.context.getOutputSuggestions()} 
                                        valRules={{ "noEmpty": true }} 
                                        disabled={this.props.readOnly} />
                                </td>
                                {!this.props.readOnly && <td className={"icon"}>
                                    <i className={"fe icon-trash-2"}
                                        onClick={() => {
                                            this.setConfig(compKey, "", "delete");
                                        }} />
                                </td>}
                            </tr></tbody></table>
                        );
                        if (i !== data.length - 1) {
                            exps.push(<div key={"and-sep" + i} style={{ padding: "4px 0" }}>AND</div>);
                        }
                    }
                    return exps;
                })()}

                {!this.props.readOnly && <table><tbody><tr>
                    {isInputNode && <td><Button label={"+ INTENT"} key={Utility.uuid4()}
                                callback={"__submenu"}
                                context={submenuContext}
                        submenu={LocalIntentSubCon}
                        isTransitionCondition={true}
                    /></td>}
                    <td><Button label={"+ SCRIPT"} key={Utility.uuid4()}
                        callback={() => {
                            if ((data.length && data[data.length - 1]) || data.length === 0) {
                                this.setState((prevState) => {
                                    const values = prevState.value;
                                    if (values[key]) {
                                        values[key].push("");
                                    } else {
                                        values[key] = [""];
                                    }
                                    return { value: values };
                                });
                            }
                        }}
                    /></td>
                </tr></tbody></table>}
            </div>
        );
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        return (
            <div className={"form-component-container"} style={{ marginTop: "8px" }}>
                {(() => {
                    if (this.state.value.length <= 0) {
                        return this.renderAnd(0, []);
                    } else {
                        var ands = [];
                        for (var i = 0; i < this.state.value.length; i++) {
                            ands.push(this.renderAnd(i, this.state.value[i]));
                            if (i !== this.state.value.length - 1) {
                                ands.push(<div key={"or-sep" + i} style={{ padding: "4px 0" }}>OR</div>);
                            }
                        }
                        return ands;

                    }
                })()}
                {!this.props.readOnly && <Button label={"+ " + this.getPropLabel("or")}
                    callback={() => {
                        if (this.state.value.length && this.state.value[this.state.value.length - 1].length) {
                            this.setState((prevState) => {
                                const values = prevState.value;
                                values.push([]);
                                values[values.length - 1].push("");
                                return { value: values };
                            });
                        }
                    }}
                />}
            </div>
        );
    }
}